import {Component, HostBinding, OnInit} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {surveyLocalization} from "survey-core";
import "survey-core/survey.i18n";
import {SurveyService} from "../../services/survey.service";
import {environment} from "../../../environments/environment";

/** Component that handles the language selection for SurveyJS */
@Component({
	selector: 'language-selector',
	imports: [
		FormsModule
	],
	templateUrl: './language-selector.component.html',
	styleUrl: './language-selector.component.scss'
})
export class LanguageSelector implements OnInit {
	/** Is the nav bar hidden */
	@HostBinding('class.hidden')
	isHidden:boolean = false;

	/** Options for the dropdown */
	public localeOptions:LocaleOption[];

	constructor(private surveyService:SurveyService) {
	}

	ngOnInit() {
		//create a list for the dropdown of all the allowed languages to select from
		this.localeOptions = environment.enabledLanguages
			.filter(value => surveyLocalization.localeNames[value] != undefined)
			.map(value => {
				return {
					title: surveyLocalization.localeNames[value],
					langCode: value
				}
			});
	}

	/** The selected locale in the system */
	get selectedLocale() {
		return this.surveyService.locale;
	}

	set selectedLocale(locale:string) {
		this.surveyService.locale = locale;
	}
}

/** Locale options to show in the language selector */
interface LocaleOption {
	title:string;
	langCode:string;
}
